import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'

import router from './router/index'
import store from './store'
import ApiService from './common/api/api.service'
import './registerServiceWorker'
import wb from "@/registerServiceWorker";
import inputUpper from "@/common/inputUpper";

import '@/plugins/apexcharts'

Vue.prototype.$workbox = wb;
Vue.config.productionTip = false

ApiService.init()

const options = {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'};


Vue.filter('formatDate', function (value) {
    if (!value) return ''
    return new Date(value).toLocaleDateString('pt-br', options)
})

Vue.filter('formatDateHour', function (value) {
    if (!value) return ''
    let dt = new Date(value)
    return dt.toLocaleTimeString('pt-br', {hour: "numeric", minute: "numeric", hour12: false})
})


Vue.filter('formatDate0', function (value) {
    if (!value) return ''
    return value.split("-").reverse().join("/")
})

Vue.filter('formatDate2', function (value) {
    if (!value) return ''
    let dt = new Date(value)
    return dt.toLocaleDateString('pt-br') + " " +
        dt.toLocaleTimeString('pt-br', {hour: "numeric", minute: "numeric", hour12: false})
})

Vue.filter('formatDate3', function (value) {
    if (!value) return ''
    let dt = new Date(value)
    return dt.toLocaleDateString('pt-br')
})

Vue.filter('money', function (value) {
    if (!value) return 'R$ 0,00'
    return new Intl.NumberFormat('pt-br', {style: 'currency', currency: 'BRL'}).format(value)
})

Vue.filter('activeText', function (value) {
    return value ? "Ativo" : "Inativo";
})

Vue.filter('percent', function (value){
    if (!value) return '0,00 %'
    console.log(value)
    return new Intl.NumberFormat('pt-br', {style: 'percent',minimumFractionDigits: 2,maximumFractionDigits: 2 }).format(value/100);
})

// Vue.directive('uppercase', {
//     bind(el, _, vnode) {
//         el.addEventListener('keyup', (e) => {
//             console.log(el, vnode)
//             e.target.value = e.target.value.toUpperCase()
//             vnode.componentInstance.$emit('input', e.target.value.toUpperCase())
//         })
//     }
// })

Vue.directive('uppercase', inputUpper)


new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app')
